<div class="nawam-splash" role="status" aria-live="polite" aria-label="Chargement de l'application">
  <img
    src="images/logo/nawam-logo.png"
    alt="Nawam"
    class="nawam-splash__logo"
  />
  <div class="nawam-splash__spinner" aria-hidden="true"></div>
</div>
